import React from 'react';
import { twoBtnPopupCreator } from '../../popups/ConfirmPopup/helper';
import { BackButton, BackButtonImg } from './InboxButton.styles';

class InboxButton extends React.Component {
  handleBackClick() {
    if (this.props.simplrTaggingActive) {
      twoBtnPopupCreator({
        content: {
          main: "You haven't taken this ticket yet!",
          iconPath: '/images/green-alert-bell.svg',
          subText: ['You must categorize the conversation to take it. Are you sure you want to exit?'],
        },
        btnConfig: {
          dismiss: 'KEEP CATEGORIZING',
          confirm: 'LEAVE',
        },
        onConfirm: () => {
          this.props.hideTools();
        },
      });
    } else if (this.props.commerceWizardActive) {
      twoBtnPopupCreator({
        content: {
          main: `You have not recommended a product.`,
          subText: [`Are you sure you want to leave?`],
          iconPath: '/images/green-alert-bell.svg',
        },
        btnConfig: {
          dismiss: 'Stay',
          confirm: 'Leave',
        },
        onConfirm: () => {
          this.props.closeCommerceWizard();
          this.props.hideTools();
        },
      });
    } else {
      this.props.hideTools();
    }
  }

  render() {
    const { toolsOpen } = this.props;

    return (
      <BackButton onClick={() => this.handleBackClick()}>
        {toolsOpen && <BackButtonImg visible={toolsOpen} src="/images/straight-back-arrow.svg" />}
      </BackButton>
    );
  }
}

export default InboxButton;
